import { useEffect, useState } from 'react';
import { authApi } from '../services/portalApi';

/**
 * Whether the signed-in site is a read-only demo.
 *
 * Cosmetic only — it disables actions so a visitor is not invited to click
 * things that will fail. The refusal itself is enforced server-side in
 * pt_rest_handler:demo_write_blocked/2; nothing here is a security boundary.
 *
 * The /me result is cached in a module-level promise so a dozen components can
 * ask without a dozen requests, and so the answer stays consistent across a
 * page rather than some buttons enabling before others.
 */
let cached: Promise<boolean> | null = null;

function fetchReadOnly(): Promise<boolean> {
  if (!cached) {
    cached = authApi
      .me()
      .then((me) => Boolean((me as { read_only?: boolean }).read_only))
      .catch(() => false); // a failed lookup must not lock a real customer out
  }
  return cached;
}

/** Call on sign-out: the next user may be on a different site. */
export function resetReadOnlyCache() {
  cached = null;
}

export function useReadOnly(): boolean {
  const [readOnly, setReadOnly] = useState(false);
  useEffect(() => {
    let alive = true;
    void fetchReadOnly().then((v) => { if (alive) setReadOnly(v); });
    return () => { alive = false; };
  }, []);
  return readOnly;
}
